const cancel = 'Cancel'
const save = 'Save'

export default {

  global: {
    generalError: 'Aw snap! The request could not be processed. Please reload the page.',
    signature: 'Best regards,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Add CV or other requested attachments',
      placeholderWithDescription: 'Add the requested attachments',
      remove: 'Remove',
      allowedFileTypes: 'Allowed file types',
      errors: {
        size: 'File is too large, maximum size for the file is 5MB.',
        empty: 'File has no data',
        invalidType: fileType => `Sorry, ${fileType} files are not permitted for security reasons`,
        typeNotWhitelisted: 'Sorry, file type is not allowed.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Privacy policy',
      termsLinkText: 'Terms and conditions',
      privacyPolicyText: 'We value your privacy, please read our ',
      termsText1: 'Read and accept the ',
      termsText2: 'before providing us your personal data.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `If you do not want us to process your personal data, you can ask for removal by sending us a message to ${mail}.`,
      customSupportPrivacyInfo: link => `If you do not want us to process your personal data, you can ask for removal by contacting ${link}.`,
    },

    buttons: {
      close: 'Close',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get the defaults',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Remove take',
      confirm: 'Try again',
    },

    confirmButton: {
      wait: count => `Wait ${count}`,
      confirm: 'Confirm',
    },

    controlStatus: {
      text: {
        empty: 'Fill in',
        valid: () => 'Ready',
      },
      textarea: {
        empty: 'Fill in',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Set',
        valid: () => 'Ready',
      },
      file: {
        empty: 'Select',
        valid: () => 'Change',
      },
      list: {
        empty: 'Add',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Search',
        valid: () => 'Ready',
      },
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Remove',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The CSV rows can contain either an email address or both an email address and a phone number. Each row represents a recipient. Phone numbers must be in international format (E.164), e.g., <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Access forbidden',
      content: 'Please make sure you are logged into the correct account and have been invited to review this position in Recright. Also make sure you are using Recright with single browser window at the same time.',
      link: 'Front page',
    },

    error404: {
      heading: 'Nothing there',
      content: 'We looked hard, but there is no web page at the address you requested. Maybe you followed an expired link or accidentally typed the wrong address.',
      link: 'Front page',
    },

    error410: {
      heading: 'Closed',
      content: 'Job cannot be shown because it is either closed or the application period has ended.',
      link: 'Front page',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Initializing...',
      connection_error_hint: 'Network connection could not be established.\nTry to reload the page.',
      permission_hint: 'You need to allow this site to use your webcam and microphone.',
      searching_camera_hint: 'Searching for a webcam...',
      camera_reserved_hint: 'Another application or web page has reserved your webcam.\nPlease close that application and reload this page.',
      camera_reserved_hint_chrome_extra: '\n\nDear Chrome user, you need to allow Recright to use Webcam from the dialog below the addressbar.',
      no_camera_hint: 'Webcam could not be found.',
      no_mic_hint: 'Microphone could not be found.',
      uploading_text: 'Uploading ...',
      rtmpt_in_use: 'This step would not be needed, if your network\nadministrator allowed RTMP. Ask us how.',
      preview_text: 'The webcam is in preview mode',
      close_text: 'Close camera',
      remove_text: 'Remove take',
      noflash_errortext_install: link => `It looks like you don't have Adobe Flash Player. You need a flash plugin to record videos. Get flash here: ${link}`,
      noflash_errortext_enable: link => `If you have already installed flash, but you still see this message. Look here: ${link}`,
      noflash_errortext_differentbrowser: 'Alternatively you can try with a browser that supports HTML5 recording. We suggest Chrome or Firefox.',
    },

    footer: {
      terms: 'User Terms and Conditions',
      license: 'General Terms of Service',
      privacyPolicy: 'Privacy policy',
      customSupport: link => `Contact ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'How would you rate your interview experience?',
      howWouldYouRateJobAd: 'How would you rate your application experience?',
      yourResponseIsAnonymous: 'Your response is anonymous.',
      thankYouFeedback: 'Thank you for your feedback!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    cookieConsentModal: {
      title: 'Our website uses cookies',
      body: 'By accepting all cookies, you agree to the storing of cookies on your device to enhance site navigation, analyse site usage, and assist in our marketing efforts.',
      learnMoreLinkText: 'Learn more about how we use cookies',
      learnMoreLink: 'https://get.recright.com/cookies/',
      manageCookies: 'Manage Cookies',
      acceptAll: 'Accept All Cookies',
      manageTitle: 'Manage consent preferences',
      necessaryCookiesTitle: 'Necessary cookies',
      necessaryCookiesBody:
        'These cookies are necessary for the website to function and cannot be switched off in our systems.',
      performanceCookiesTitle: 'Performance cookies',
      performanceCookiesBody:
        'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.',
      marketingCookiesTitle: 'Marketing cookies',
      marketingCookiesBody:
        'These cookies allow us to personalise advertisement and measure ad performance.',
      functionalCookiesTitle: 'Functionality cookies',
      functionalCookiesBody:
        'These cookies are used to enhance the functionality of the website. Without these cookies, certain functionality may become unavailable. Examples of functionality cookies include web chat services, and user preferences.',
      confirmChoices: 'Confirm My Choices',
    },

    formErrors: {
      typeNotWhitelisted: 'Sorry, file type is not allowed.',
      isRequired: 'This field is mandatory.',
      invalidUrl: 'URL is invalid.',
      isEmail: value => `${value} is not a valid email.`,
      isDate: value => `${value} is not a valid date.`,
      singleHireEndError: 'Single hire can\'t be used more than 60 days.',
      isNotTooOldForLive: 'Date is in the past.',
      isNotAfterEndDate: 'The selected date can\'t be after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists.',
    },

    jobAdApplication: {
      name: 'Name',
      city: 'Hometown',
      email: 'Email',
      phone: 'Phone Number',
      applyForPosition: 'Apply for position',
      back: 'Back',
      continue: 'Continue',
      submit: 'Submit',
      saveForLater: 'Continue later',
      namePlaceholder: 'Enter your name',
      emailPlaceholder: 'Enter your email address',
      phonePlaceholder: 'Enter your phone number',
      cityPlaceholder: 'Enter your current hometown',
      links: 'Add links, for example your LinkedIn profile',
      legendBasicInfo: 'Basic information',
      legendLinks: 'Links',
      legendAttachments: 'Attachments',
      legendAdditionalFields: 'Additional information',
      coverLetter: 'Cover letter',
      attachments: 'Attachments',
      introduction: 'Write your short introduction here',
      thankYou: 'Thank you.',
      luck: 'Best of luck!',
      close: 'Close',
      required: 'Items marked with an * asterisk are mandatory.',
    },

    jobAdContainer: {
      endTime: date => (date ? `open until ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Apply for job',
    },

    jobAdQuickInterview: {
      back: 'Back',
      submit: 'Submit',
      saveForLater: 'Continue later',
      title: 'Quick video interview',
      description: 'To get to know you faster we would like you to briefly answer to our quick interview question. Bring in your personality and give your application a soul.',
      requiredNote: 'Note that this is one part of the application process, and recruiter will receive your application only after you have recorded your answer.',
      reminderNote: 'You can record the answer right away, or you can continue later by receiving a reminder to your email.',
    },

    jobAdRow: {
      responses: 'Applications',
      status: {
        open: 'Open',
        filled: 'Filled',
        cancelled: 'Cancelled',
        done: 'Done',
        close: 'Close',
        draft: 'Closed (draft)',
        hidden: 'Hidden',
      },
    },

    interviewRow: {
      responses: 'Candidates',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Show LinkedIn profile',
    },

    linkedInButton: {
      error: 'Error while fetching the profile. Please try again.',
      buttonText: 'Apply with LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'You can use your LinkedIn profile to pre-fill the application form',
      linkedInOr: 'Or',
      error: 'Error while fetching the profile. Please try again.',
    },

    linkListInput: {
      addField: 'Add',
      removeField: 'Remove',
      invalidUrl: 'URL is invalid.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Loading...',
      saving: 'Saving...',
      sending: 'Sending...',
    },

    modalApplicationForm: {
      applyForPosition: 'Apply for position',
      continue: 'Continue',
      name: 'Enter your name',
      email: 'Enter your email address',
      phoneNumber: 'Enter your phone number',
      links: 'You may enter links',
      legendLinks: 'Links',
      legendAttachments: 'Attachments',
      coverLetter: 'Cover letter',
      attachments: 'Attachments',
      introduction: 'Write your introduction here',
      thankYou: 'Thank you.',
      luck: 'Best of luck!',
      close: 'Close',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Shareable public link',
      info: 'Here\'s a job ad\'s public address you can share.\nAnyone interested in the position can see the job ad \nand then decide to apply.\nYou\'ll receive the usual notification when applications start arriving.\n\nHere\'s a public link to the job ad:',
    },

    modalVideoAdd: {
      chooseTitle: 'Add a new video',
      title: 'Record a new video',
      titlePlaceholder: 'Enter video title here',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Upload a new video',
      info: 'Maximum allowed video size is 500mb. We recommend that the videos are compressed before uploading, this way upload and conversion will take less time.',
    },

    modalCandidateInfo: [
      {
        headline: 'Record your video response ',
        content: 'as many times as you wish. Videos will be saved immediately after recording and you can return to the video interview via the link you received to your e-mail.',
        mobileContent: 'as many times as you wish. Add the video to the interview. You will see the video being uploaded and saved in the interview. You can return to the video interview via the link you received to your e-mail. <br><br><strong>If your video screen remains black and you are using an Apple mobile device, you will find instructions on how to solve the problem <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">here</a>.</strong>',
      },
      {
        headline: 'After recording, ',
        content: 'make sure that the video plays correctly and your voice can be heard. When you press “Submit”-button, your answer will be locked and you can’t edit it anymore.',
      },
      {
        headline: 'When you are finished with the interview, ',
        content: 'press “Send answers and complete interview” -button. After this you can’t go back to the video interview. If you wish to close this page but continue later with the interview, press “Continue later” -button.',
      },
      {
        headline: 'If you need help ',
        content: mailto => `in answering to the video interview, click the “help” button on the bottom right-hand side of the page or send us an email to ${mailto}.`,
        customContent: link => `Contact ${link}`,
      },
    ],

    navigationBar: {
      back: 'Back',
      dashboard: 'Dashboard',
      frontpage: 'Front page',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Meeting information',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: '',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Phone in format ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Average rating',
      reset: 'reset',
    },

    share: {
      share: 'Share to',
      copy: 'Copy link',
    },

    sort: {
      sort: 'Sort',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Selected',
      change: 'Change',
    },

    video: {
      videoNotFound: 'Video is being processed or video is not found',
      retry: 'Try again',
      originalLanguageLabel: 'Original',
      englishLanguageLabel: 'English',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Upload or record a new video' : 'Select file'),
      videoPlaceholder: 'Record your response',
      uploadPlaceholderCandidate: 'Upload your response',
      submit: 'Submit response',
      notAnswered: 'You have not yet answered',
      remove: 'Remove take',
      converting: 'Video is being converted. Please wait...',
      uploading: 'Video is being uploaded. Please wait...',
      error: {
        invalid: 'Selected file is too large. Please select another file.',
        upload: 'We were unable to upload the video, apologies. Please try again.',
        transcode: 'The video file selected was corrupted or not valid, please try again.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Show more',
      showLessButtonText: 'Show less',
      infoText1:
        'Keep the tab active on the foreground while recording. You should not use any other application while recording.',
      infoText2:
        'Video background videos work best on the latest browsers and with a device that is relatively new and powerful.',
      infoText3:
        'Make sure other applications are not using your microphone or camera.',
    },

    videoResponse: {
      videoPlaceholder: 'Record your response',
      uploadPlaceholder: 'Upload your response',
      submit: 'Submit response',
      notAnswered: 'You have not yet answered',
      required: 'This question requires an answer',
      startInterview: 'Start interview',
    },

    webcam: {
      useVideoBgButtonText: 'Use video background',
      removeVideoBgButtonText: 'Remove video background',
      starting: 'Starting...',
      close: 'Close camera',
      remove: 'Remove take',
      record: 'Record',
      stop: 'Stop',
      retake: 'Retake',
      submit: 'Submit response',
      converting: 'Video is being converted. Please wait...',
      uploading: 'Video is being uploaded. Please wait...',
      downloading: 'Video is being downloaded. Please wait...',
      processing: 'Processing...',
      uploadInProgress: 'Video transfer is still in progress, do not close the browser or change the page.',
      uploaded: 'Video transferred.',
      error: {
        DevicesNotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotAllowedError: 'You didn\'t give a permission to use the camera or microphone.',
        PermissionDismissedError: 'You dismissed permission dialog. Please give permission to use the camera and microphone.',
        PermissionDeniedError: 'You have denied camera or microphone access.',
        NotReadableError: 'Can\'t read camera or microphone stream. Possible hardware issue.',
        SecurityError: 'Can\'t use camera or microphone because of security error',
        stream: 'An error occured. Please start your browser again. If the problem persists, please try with a different browser.',
        download: 'Video download failed. Try again?',
        upload: 'Video upload failed. Try again?',
        emptyBlob: 'Your browser or device memory is full and it is unable to build the recording. Please refresh the page and if that doesn\'t help restart the browser.  If the problem persists, please try with a different browser.',
        alternativeRecorder: 'You can also use file upload by clicking this.',
        reconnecting: 'The connection was interrupted. Trying to reconnect.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Hi! We want to invite you to a video interview ${title}! This invitation was also sent to your email. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
